module.exports = __webpack_public_path__ + "static/img/InvitationCode.278d6e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Instruction/InvitationCode.png
// module id = 1745
// module chunks = 36 37